import React, { Component } from "react";
import { Switch, Router, Route, Redirect } from "react-router-dom";
import createHistory from "history/createBrowserHistory";
// Fixed components
import Nav from "./components/Nav/Nav";
// Icons/assets
import Logo from "./assets/logos/logo.png";
import CustomersIcon from "./assets/icons/customers.png";
import AcquirorsIcon from "./assets/icons/acquirors.png";
import AcquireesIcon from "./assets/icons/acquirees.png";
import SuccessImg from "./assets/icons/success.png";
import Trianglify from "./assets/trianglify/trianglify.svg";
// Sign in component
import SignIn from "./components/SignIn/SignIn";
// Sign up components
import SignUp from "./components/SignUp/SignUp";
import Success from "./components/SignUp/Success/Success";
// Sign up components
import SignUpBuyer from "./components/BuyerList/SignUp";
import SuccessBuyer from "./components/BuyerList/Success/Success";
// Dashboard homepage
import DashboardHome from "./components/DashboardHome/DashboardHome";
// Main search & search results components
import Search from "./components/Search/Search";
import SearchResults from "./components/SearchResults/SearchResults";
import NoResults from "./components/SearchResults/NoResults/NoResults";
// Company search results component
import CompanyResults from "./components/CompanyResults/CompanyResults";
// Account page
import Account from "./components/Account/Account";
import EditAccount from "./components/Account/EditAccount/EditAccount";
// 404 page
import NoMatch from "./components/NoMatch/NoMatch";
// Utilities
import axios from "axios";
import "antd/dist/antd.css";
import "./App.css";

axios.defaults.withCredentials = true;
const history = createHistory();

class App extends Component {
    constructor(props) {
        super(props);
        var global = require("./global.js");
        this.state = {
            serverUrl: global.server_url,
            requestInProgress: false,
            user: false,
            signUpParams: {
                firstName: "",
                lastName: "",
                institution: "",
                user: "",
                pass: "",
                pass2: "",
                searchProducts: []
            },
            signUpParamsBuyer: {
                email: "",
                name: "",
                web: "",
                business: "",
                price: "",
                neighbor: "",
                buyer_business: "",
            },
            loginParams: {
                user: "",
                pass: "",
                cookieFlag: false
            },
            updateAccountParams: {
                email: "",
                password: "",
                newPassword: "",
                firstName: "",
                lastName: "",
                company: ""
            },
            accountInfo: {},
            searchProducts: [
                //  {
                //      name: "customers",
                //      desc: "Find hundreds of potential customers in seconds.",
                //      price: 150,
                //      icon: CustomersIcon,
                //      selected: false
                //  },
                {
                    name: "acquirers",
                    desc:
                        "Find available acquirers specializing in your industry.",
                    price: 99,
                    icon: AcquirorsIcon,
                    selected: false
                },
                {
                    name: "targets",
                    desc:
                        "Screen acquisition targets in accordance to certain criteria.",
                    price: 99,
                    icon: AcquireesIcon,
                    selected: false
                }
            ],
            
            searchProductsTrial: [
                //  {
                //      name: "customers",
                //      desc: "Find hundreds of potential customers in seconds.",
                //      price: 150,
                //      icon: CustomersIcon,
                //      selected: false
                //  },
                {
                    name: "acquirers",
                    desc:
                        "Find available acquirers specializing in your industry.",
                    price: 0,
                    icon: AcquirorsIcon,
                    selected: false
                },
                {
                    name: "targets",
                    desc:
                        "Screen acquisition targets in accordance to certain criteria.",
                    price: 0,
                    icon: AcquireesIcon,
                    selected: false
                }
            ],
            onboardingFlow: {
                0: "create account",
                1: "select products",
                2: "payment"
            },
            onboardingStep: 0,
            
            onboardingFlowBuyer: {
                0: "general information",
                1: "company information",
                2: "m&a deal information",
                3: "payment"
            },
            onboardingStepBuyer: 0,
            query: {
                type: "acquirers"
            },
            moreFilters: false,
            countries: {
                Afghanistan: "AFG",
                "Åland Islands": "ALA",
                Albania: "ALB",
                Algeria: "DZA",
                "American Samoa": "ASM",
                Andorra: "AND",
                Angola: "AGO",
                Anguilla: "AIA",
                Antarctica: "ATA",
                "Antigua and Barbuda": "ATG",
                Argentina: "ARG",
                Armenia: "ARM",
                Aruba: "ABW",
                Australia: "AUS",
                Austria: "AUT",
                Azerbaijan: "AZE",
                Bahamas: "BHS",
                Bahrain: "BHR",
                Bangladesh: "BGD",
                Barbados: "BRB",
                Belarus: "BLR",
                Belgium: "BEL",
                Belize: "BLZ",
                Benin: "BEN",
                Bermuda: "BMU",
                Bhutan: "BTN",
                "Bolivia (Plurinational State of)": "BOL",
                "Bonaire, Sint Eustatius and Saba": "BES",
                "Bosnia and Herzegovina": "BIH",
                Botswana: "BWA",
                "Bouvet Island": "BVT",
                Brazil: "BRA",
                "British Indian Ocean Territory": "IOT",
                "Brunei Darussalam": "BRN",
                Bulgaria: "BGR",
                "Burkina Faso": "BFA",
                Burundi: "BDI",
                "Cabo Verde": "CPV",
                Cambodia: "KHM",
                Cameroon: "CMR",
                Canada: "CAN",
                "Cayman Islands": "CYM",
                "Central African Republic": "CAF",
                Chad: "TCD",
                Chile: "CHL",
                China: "CHN",
                "Christmas Island": "CXR",
                "Cocos (Keeling) Islands": "CCK",
                Colombia: "COL",
                Comoros: "COM",
                Congo: "COG",
                "Congo (Democratic Republic of the)": "COD",
                "Cook Islands": "COK",
                "Costa Rica": "CRI",
                "Côte d'Ivoire": "CIV",
                Croatia: "HRV",
                Cuba: "CUB",
                Curaçao: "CUW",
                Cyprus: "CYP",
                Czechia: "CZE",
                Denmark: "DNK",
                Djibouti: "DJI",
                Dominica: "DMA",
                "Dominican Republic": "DOM",
                Ecuador: "ECU",
                Egypt: "EGY",
                "El Salvador": "SLV",
                "Equatorial Guinea": "GNQ",
                Eritrea: "ERI",
                Estonia: "EST",
                Eswatini: "SWZ",
                Ethiopia: "ETH",
                "Falkland Islands (Malvinas)": "FLK",
                "Faroe Islands": "FRO",
                Fiji: "FJI",
                Finland: "FIN",
                France: "FRA",
                "French Guiana": "GUF",
                "French Polynesia": "PYF",
                "French Southern Territories": "ATF",
                Gabon: "GAB",
                Gambia: "GMB",
                Georgia: "GEO",
                Germany: "DEU",
                Ghana: "GHA",
                Gibraltar: "GIB",
                Greece: "GRC",
                Greenland: "GRL",
                Grenada: "GRD",
                Guadeloupe: "GLP",
                Guam: "GUM",
                Guatemala: "GTM",
                Guernsey: "GGY",
                Guinea: "GIN",
                "Guinea-Bissau": "GNB",
                Guyana: "GUY",
                Haiti: "HTI",
                "Heard Island and McDonald Islands": "HMD",
                "Holy See": "VAT",
                Honduras: "HND",
                "Hong Kong": "HKG",
                Hungary: "HUN",
                Iceland: "ISL",
                India: "IND",
                Indonesia: "IDN",
                "Iran (Islamic Republic of)": "IRN",
                Iraq: "IRQ",
                Ireland: "IRL",
                "Isle of Man": "IMN",
                Israel: "ISR",
                Italy: "ITA",
                Jamaica: "JAM",
                Japan: "JPN",
                Jersey: "JEY",
                Jordan: "JOR",
                Kazakhstan: "KAZ",
                Kenya: "KEN",
                Kiribati: "KIR",
                "Korea (Democratic People's Republic of)": "PRK",
                "Korea (Republic of)": "KOR",
                Kuwait: "KWT",
                Kyrgyzstan: "KGZ",
                "Lao People's Democratic Republic": "LAO",
                Latvia: "LVA",
                Lebanon: "LBN",
                Lesotho: "LSO",
                Liberia: "LBR",
                Libya: "LBY",
                Liechtenstein: "LIE",
                Lithuania: "LTU",
                Luxembourg: "LUX",
                Macao: "MAC",
                "Macedonia (the former Yugoslav Republic of)": "MKD",
                Madagascar: "MDG",
                Malawi: "MWI",
                Malaysia: "MYS",
                Maldives: "MDV",
                Mali: "MLI",
                Malta: "MLT",
                "Marshall Islands": "MHL",
                Martinique: "MTQ",
                Mauritania: "MRT",
                Mauritius: "MUS",
                Mayotte: "MYT",
                Mexico: "MEX",
                "Micronesia (Federated States of)": "FSM",
                "Moldova (Republic of)": "MDA",
                Monaco: "MCO",
                Mongolia: "MNG",
                Montenegro: "MNE",
                Montserrat: "MSR",
                Morocco: "MAR",
                Mozambique: "MOZ",
                Myanmar: "MMR",
                Namibia: "NAM",
                Nauru: "NRU",
                Nepal: "NPL",
                Netherlands: "NLD",
                "New Caledonia": "NCL",
                "New Zealand": "NZL",
                Nicaragua: "NIC",
                Niger: "NER",
                Nigeria: "NGA",
                Niue: "NIU",
                "Norfolk Island": "NFK",
                "Northern Mariana Islands": "MNP",
                Norway: "NOR",
                Oman: "OMN",
                Pakistan: "PAK",
                Palau: "PLW",
                "Palestine, State of": "PSE",
                Panama: "PAN",
                "Papua New Guinea": "PNG",
                Paraguay: "PRY",
                Peru: "PER",
                Philippines: "PHL",
                Pitcairn: "PCN",
                Poland: "POL",
                Portugal: "PRT",
                "Puerto Rico": "PRI",
                Qatar: "QAT",
                Réunion: "REU",
                Romania: "ROU",
                "Russian Federation": "RUS",
                Rwanda: "RWA",
                "Saint Barthélemy": "BLM",
                "Saint Helena, Ascension and Tristan da Cunha": "SHN",
                "Saint Kitts and Nevis": "KNA",
                "Saint Lucia": "LCA",
                "Saint Martin (French part)": "MAF",
                "Saint Pierre and Miquelon": "SPM",
                "Saint Vincent and the Grenadines": "VCT",
                Samoa: "WSM",
                "San Marino": "SMR",
                "Sao Tome and Principe": "STP",
                "Saudi Arabia": "SAU",
                Senegal: "SEN",
                Serbia: "SRB",
                Seychelles: "SYC",
                "Sierra Leone": "SLE",
                Singapore: "SGP",
                "Sint Maarten (Dutch part)": "SXM",
                Slovakia: "SVK",
                Slovenia: "SVN",
                "Solomon Islands": "SLB",
                Somalia: "SOM",
                "South Africa": "ZAF",
                "South Georgia and the South Sandwich Islands": "SGS",
                "South Sudan": "SSD",
                Spain: "ESP",
                "Sri Lanka": "LKA",
                Sudan: "SDN",
                Suriname: "SUR",
                "Svalbard and Jan Mayen": "SJM",
                Sweden: "SWE",
                Switzerland: "CHE",
                "Syrian Arab Republic": "SYR",
                "Taiwan": "TWN",
                Tajikistan: "TJK",
                "Tanzania, United Republic of": "TZA",
                Thailand: "THA",
                "Timor-Leste": "TLS",
                Togo: "TGO",
                Tokelau: "TKL",
                Tonga: "TON",
                "Trinidad and Tobago": "TTO",
                Tunisia: "TUN",
                Turkey: "TUR",
                Turkmenistan: "TKM",
                "Turks and Caicos Islands": "TCA",
                Tuvalu: "TUV",
                Uganda: "UGA",
                Ukraine: "UKR",
                "United Arab Emirates": "ARE",
                "United Kingdom of Great Britain and Northern Ireland": "GBR",
                "United States of America": "USA",
                "United States Minor Outlying Islands": "UMI",
                Uruguay: "URY",
                Uzbekistan: "UZB",
                Vanuatu: "VUT",
                "Venezuela (Bolivarian Republic of)": "VEN",
                "Viet Nam": "VNM",
                "Virgin Islands (British)": "VGB",
                "Virgin Islands (U.S.)": "VIR",
                "Wallis and Futuna": "WLF",
                "Western Sahara": "ESH",
                Yemen: "YEM",
                Zambia: "ZMB",
                Zimbabwe: "ZWE"
            },
            searchResults: [],
            revealSearchPanel: false,
            dataToExport: [],
            companyContacts: [],
            showCompanyContacts: false,
            recentSearches: [],
            recentAcq: []
        };
        this.onChangeInput = this.onChangeInput.bind(this);
        this.onboardingMinimumOne = this.onboardingMinimumOne.bind(this);
        this.onboardingMinimumTwo = this.onboardingMinimumTwo.bind(this);
        this.addToOnboardingCart = this.addToOnboardingCart.bind(this);
        this.verifyUser = this.verifyUser.bind(this);
        this.changeLocation = this.changeLocation.bind(this);
        this.changeLocation2 = this.changeLocation2.bind(this);
        this.returnIndustriesArray = this.returnIndustriesArray.bind(this);
        this.addSearchTypeToQuery = this.addSearchTypeToQuery.bind(this);
        this.buildSearchQuery = this.buildSearchQuery.bind(this);
        this.validateSearchQuery = this.validateSearchQuery.bind(this);
        this.requestSearchResults = this.requestSearchResults.bind(this);
        this.selectDataToExport = this.selectDataToExport.bind(this);
        this.jsonToCsv = this.jsonToCsv.bind(this);
        this.getAccountInfo = this.getAccountInfo.bind(this);
        this.unsubcribePlan = this.unsubcribePlan.bind(this);
        this.refreshedAccountInfo = this.refreshedAccountInfo.bind(this);
        this.refreshedSearchResults = this.refreshedSearchResults.bind(this);
        this.toggleMoreFilters = this.toggleMoreFilters.bind(this);
    }
    componentWillMount() {
        this.checkForUser();
    }
    checkForUser() {
        let user = JSON.parse(sessionStorage.getItem("accountInfo"));

        if (user !== null) {
            this.setState({ user: true });
        } else {
            this.setState({ user: false });
        }
    }
    onChangeInput(key, val, paramType) {
        // adds parameters to login/signup/edit account obj in state
        let params = this.state[paramType];
        params[key] = val;
        this.setState({ params });
    }
    nextOnboarding(e) {
        // switches onboarding flow
        e.preventDefault();
        // if on sign up form
        // validate all fields are complete
        if (this.state.onboardingStep === 0) {
            let validateSignUpParams = Object.values(
                this.state.signUpParams
            ).every(p => p !== "");
            if (validateSignUpParams === false) {
                alert("Please complete all fields in the sign up form.");
            } else {
                // if params are complete, move to next screen
                // add products array
                // let signUpParams = this.state.signUpParams;
                // signUpParams["searchProducts"] = [];
                this.setState({ onboardingStep: 1 });
            }
        } else if (this.state.onboardingStep === 1) {
            if (this.state.signUpParams["searchProducts"].length !== 2) {
                this.onboardingMinimumTwo();
            } else {
                this.setState({ onboardingStep: 2 });
            }
        }
    }
    backOnboarding() {
        this.setState({ onboardingStep: this.state.onboardingStep - 1 });
    }
    
    
    nextOnboardingBuyer(e) {
        // switches onboarding flow
        e.preventDefault();
        // if on sign up form
        // validate all fields are complete
        if (this.state.onboardingStepBuyer === 0) {
            let validateSignUpParams = true;
	            
            if (this.state.signUpParamsBuyer.email === "")
	            validateSignUpParams = false;
	
            if (validateSignUpParams === false) {
                alert("Please complete all required fields in the sign up form.");
            } 
            else {
                // if params are complete, move to next screen
                this.setState({ onboardingStepBuyer: 1 });
            }
        } 
        else if (this.state.onboardingStepBuyer === 1) {
            let validateSignUpParams = true;
	            
            if (this.state.signUpParamsBuyer.business === "")
	            validateSignUpParams = false;
	
            if (validateSignUpParams === false) {
                alert("Please complete all required fields in the sign up form.");
            } 
            else {
                // if params are complete, move to next screen
                this.setState({ onboardingStepBuyer: 2 });
            }
        }
        
        else if (this.state.onboardingStepBuyer >= 2) {
               this.setState({ onboardingStepBuyer: this.state.onboardingStepBuyer+1 });
        }
    }
    
    nextOnboardingBuyer2(e) {
        // switches onboarding flow
        e.preventDefault();
        // if on sign up form
        // validate all fields are complete
        if (this.state.onboardingStepBuyer === 0) {
        
        this.state.signUpParamsBuyer
            let validateSignUpParams = true;
            
            if (this.state.signUpParamsBuyer.email === "" || this.state.signUpParamsBuyer.business === "")
	            validateSignUpParams = false;

            if (validateSignUpParams === false) {
                alert("Please complete all required fields in the sign up form.");
            } else {
                // if params are complete, move to next screen
                this.setState({ onboardingStepBuyer: 1 });
            }
        } 
    }
    backOnboardingBuyer() {
        this.setState({ onboardingStepBuyer: this.state.onboardingStepBuyer - 1 });
    }
    
    
    postLogin(e) {
        e.preventDefault();
        // check that all params are valid
        let validateLoginParams = Object.values(this.state.loginParams).every(
            p => p !== ""
        );

        let loginParams = this.state.loginParams;

        if (validateLoginParams === true) {
            // remove cookieFlag if user doesn't want to have cookie saved
            if (this.state.loginParams["cookieFlag"] === false) {
                delete loginParams["cookieFlag"];
            }

            // POST if loginParamsToString is true (all params are valid)
            axios
                .post(
                    `${this.state.serverUrl}/service/financekb/login`,
                    loginParams
                )
                .then(res => {
                    if (res.data.success === true) {
                        // redirect to dashboard, get industries, get
                        //this.getIndustriesArray();
                        setTimeout(() => {
                            this.setState({ user: true });
                            this.getAccountInfo();
                            this.changeLocation("/dashboard/search");
                        }, 1);
                    } else {
                        alert(
                            "Your login credentials are incorrect. Please try again."
                        );
                        window.location.reload();
                    }
                })
                .catch(err => {
                    console.log(`Error logging in: ${err}`);
                });
        } else {
            alert("Please fill out each field before attemping to log in.");
        }
    }
    logOutUser() {
        axios
            .post(`${this.state.serverUrl}/service/webservice/logout`, {
                withCredentials: true
            })
            .then(res => {
                sessionStorage.clear();
                alert("You have successfully logged out.");
                window.location = "/";
            })
            .catch(err => {
                console.log(err);
            });
    }
    onboardingMinimumOne() {
        // require user to select at least one item
        alert("Please select at least one item before continuing.");
    }
    onboardingMinimumTwo() {
        // require user to select at least one item
        alert("Please select both items before continuing.");
    }
    addToOnboardingCart(product) {
        let signUpParams = this.state.signUpParams;
        signUpParams["searchProducts"].push(product);
        this.setState({ signUpParams });

        this.selectSearchProduct(product);
    }
    selectSearchProduct(product) {
        // activate search products during onboarding
        // to customize console
        let filterProds = this.state.searchProducts.filter(p => {
            return p.name === product;
        });
        filterProds[0].selected = true;

        this.setState({ filterProds });
    }
    getSignUpProductTotal() {
        let total = 0;

        if (this.state.onboardingStep === 2) {
            this.state.signUpParams.searchProducts.forEach(selected => {
                this.state.searchProducts.find(prodFromList => {
                    if (prodFromList.name === selected) {
                        total = total + prodFromList.price;
                    }
                });
            });
        }

        return total;
    }
    
    getSignUpProductTotalBuyer() {
        let total = 69.99;
        return total;
    }
    
    onToken(token) {
        let searchProds = this.state.signUpParams["searchProducts"].slice();
        searchProds.forEach(s => {
            if (s === "acquisition") {
                searchProds[searchProds.indexOf(s)] = "recommend_acquiror\tfind_company_app";
            }
            if (s === "acquirers") {
                searchProds[searchProds.indexOf(s)] = "recommend_acquiror";
            }
            if (s === "targets") {
                searchProds[searchProds.indexOf(s)] = "find_company_app";
            }
            if (s === "customers") {
                searchProds[searchProds.indexOf(s)] = "recommend_customer";
            }
        });

        let data = {
            first_name: this.state.signUpParams["firstName"],
            last_name: this.state.signUpParams["lastName"],
            email: this.state.signUpParams["user"],
            institution: this.state.signUpParams["institution"],
            pass_word: this.state.signUpParams["pass"],
            pass_word2: this.state.signUpParams["pass2"],
            interests: searchProds.join("\t"),
            stripeToken: token.id
        };

        axios
            .post(
                `${this.state
                    .serverUrl}/service/webservice/subscribe_acquisition_service`,
                data,
                {
                    withCredentials: true
                }
            )
            .then(response => {
                if (response.data.success === true) {
                    sessionStorage.clear();
                    alert(
                        "Your account and plan have been created! You will now be redirected to the sign in page."
                    );
                    window.location = "/";
                } else {
                    alert("Account creation has failed. "+response.data.message+". Please try again.");
                    window.location.reload();
                }
            });
    }
    
    onTokenBuyer(token) {

        let data = {
            name: this.state.signUpParamsBuyer["name"],
            email: this.state.signUpParamsBuyer["email"],
            company_name: this.state.signUpParamsBuyer["company_name"],
            web: this.state.signUpParamsBuyer["web"],
            location: this.state.signUpParamsBuyer["location"],
            founded: this.state.signUpParamsBuyer["founded"],
            business: this.state.signUpParamsBuyer["business"],
            employee_number: this.state.signUpParamsBuyer["employee_number"],
            customer_number: this.state.signUpParamsBuyer["customer_number"],
            customer_industry: this.state.signUpParamsBuyer["customer_industry"],
            price: this.state.signUpParamsBuyer["price"],
            revenue: this.state.signUpParamsBuyer["revenue"],
            funding: this.state.signUpParamsBuyer["funding"],
            neighbor: this.state.signUpParamsBuyer["neighbor"],
            buyer_business: this.state.signUpParamsBuyer["buyer_business"],
            stripeToken: token.id
        };

        axios
            .post(
                `${this.state
                    .serverUrl}/service/financekb/generate_buyer_list`,
                data,
                {
                    withCredentials: true
                }
            )
            .then(response => {
                if (response.data.success === true) {
                    sessionStorage.clear();
                    alert(
                        "Your request has been succefully submitted. We will send you the buyer list in 24 hours."
                    );
                    window.location = "https://www.fmeasure.com";
                } else {
                    alert("Request submission has failed. "+response.data.message+". Please try again.");
                    window.location.reload();
                }
            });
    }
    verifyUser(render) {
        // verify a user or send to 404
        return this.state.user ? render : <Redirect to="/404" />;
    }
    changeLocation(location, newWindow) {
        if (newWindow !== undefined) {
            var newTab = window.open(location, "_blank");
            newTab.focus();
            window.location.href = window.location.href;
        } else {
 	       	if (location.includes("http"))
    	    	window.open(location, "_self");
        	else
            	history.push(location);
        }
    }
    
    changeLocation2(location, newWindow) {
        if (newWindow !== undefined) {
            var newTab = window.open(location, "_blank");
            newTab.focus();
           // window.location.href = window.location.href;
        } else {
            history.push(location);
        }
    }    
    getIndustriesArray() {
        axios
            .post(`${this.state.serverUrl}/service/financekb/get_sic_hierarchy`)
            .then(res => {
                //console.log(res);
                let sortedIndustryArray = res.data.result
                    .map(d => {
                        return d.name;
                    })
                    .sort();
                sessionStorage.setItem(
                    "industries",
                    JSON.stringify(sortedIndustryArray)
                );
            })
            .catch(error => {
                console.log(error);
                alert(
                    "Sorry, we're having issues connecting with our servers. Please try again in a few minutes."
                );
            });
    }
    returnIndustriesArray() {
        let data = JSON.parse(sessionStorage.getItem("industries"));
        return data;
    }
    buildSearchQuery(key, value) {
        let q = this.state.query;
        q[key] = value;
        this.setState({ q });
    }
    addSearchTypeToQuery(type) {
        let q = this.state.query;
        q.type = type;
        this.setState({ q });
    }
    toggleMoreFilters() {
        this.setState({ moreFilters: !this.state.moreFilters });
    }
    validateSearchQuery() {
        this.setState({ requestInProgress: true });
        sessionStorage.setItem("searchQuery", JSON.stringify(this.state.query));
        if (this.state.query.type === "acquirers") {
            this.assembleAcquirorsDataBeforeSearch();
        } else if (this.state.query.type === "targets") {
            this.assembleAcquireesDataBeforeSearch();
        } else {
            this.assembleCustomersDataBeforeSearch();
        }
    }
    
    resubmitSearchQuery(data, endpoint) {
    	this.setState({ requestInProgress: true });
        sessionStorage.setItem("searchQuery", JSON.stringify(data));
        if (data=== null)
        	data= { type: "acquirers"};
        this.setState({ query: data });
        this.requestSearchResults(data, endpoint);
    }
    
    assembleAcquirorsDataBeforeSearch() {
        let q = this.state.query;

        let data = {
            acquiror_business: q.business
        };

        // customer location and existing customers are optional fields
        if (q.region) {
            let countryNamesToIso = q.region.map(m => {
                return this.state.countries[m];
            });
            data["acquiror_location"] = countryNamesToIso.join(";");
        }
        if (q.industry) {
            data["acquiror_industry"] = q.industry.join(";");
        }
        if (q.ownBusiness) {
            data["acquiree_business"] = q.ownBusiness;
        }

        if (q.acquirorNeighbor) {
            data["acquiror_neighbor"] = q.acquirorNeighbor;
        }
        
        var x="";
        if (q.liabilities) {
        	if (x==="") {
        		x=q.liabilities;
        	}
        	else {
        		x=x+";"+q.liabilities;
        	}
        }
        if (q.grossmargin) {
        	if (x==="") {
        		x=q.grossmargin;
        	}
        	else {
        		x=x+";"+q.grossmargin;
        	}
        }
        if (x!=="") {
        	data["acquiror_financial"]=x;
        }
        
        x="";
        if (q.cash_needed_in_m) {
       		x=q.cash_needed_in_m;
        }
        if (x!=="") {
        	data["cash_needed_in_m"]=x;
        }
        
        this.requestSearchResults(
            data,
            "/service/financekb/recommend_acquiror"
        );
    }
    assembleAcquireesDataBeforeSearch() {
        let q = this.state.query;

        let data = {
            company_business: q.business
        };

        // acquiree location and known acquiree candidates are optional fields
        if (q.region) {
            let countryNamesToIso = q.region.map(m => {
                return this.state.countries[m];
            });
            data["company_location"] = countryNamesToIso.join(";");
        }
        if (q.industry) {
            data["company_industry"] = q.industry.join(";");
        }
        if (q.ownBusiness) {
            data["acquiror_business"] = q.ownBusiness;
        }

        if (q.companyNeighbor) {
            data["company_neighbor"] = q.companyNeighbor;
        }
        
        var x="";
        if (q.liabilities) {
        	if (x==="") {
        		x=q.liabilities;
        	}
        	else {
        		x=x+";"+q.liabilities;
        	}
        }
        if (q.grossmargin) {
        	if (x==="") {
        		x=q.grossmargin;
        	}
        	else {
        		x=x+";"+q.grossmargin;
        	}
        }
        if (x!=="") {
        	data["company_financial"]=x;
        }
        this.requestSearchResults(data, "/service/financekb/find_company");
    }
    assembleCustomersDataBeforeSearch() {
        let q = this.state.query;

        let data = {};

        if (q.business) {
            data["customer_business"] = q.business;
        }

        // customer location and existing customers are optional fields
        if (q.region) {
            let countryNamesToIso = q.region.map(m => {
                return this.state.countries[m];
            });
            data["customer_location"] = countryNamesToIso.join(";");
        }
        if (q.existingCustomers) {
            data["existing_customer"] = q.existingCustomers.join("%26");
        }
        if (q.potentialCustomers) {
            data["potential_customer"] = q.potentialCustomers.join("%26");
        }
        if (q.industry) {
            data["industry"] = q.industry.join(";");
        }
        if (q.ownBusiness) {
            data["own_business"] = q.ownBusiness;
        }

        this.requestSearchResults(
            data,
            "/service/financekb/recommend_customer"
        );
    }
    requestSearchResults(data, endPoint) {
        axios
            .post(`${this.state.serverUrl}${endPoint}`, data, {
                withCredentials: true
            })
            .then(res => {
                this.setState({ requestInProgress: false });

				if ("login" in res.data && res.data["login"]==='fail') {
                        alert(
                            "Your login credentials are either empty or incorrect. Please try again."
                        );
                         window.location = "/";
                }
                else if (res.data["result"].length === 0) {
                    history.push("/dashboard/search/no-results");
                } 
                else {
                    this.setState({ searchResults: res.data["result"] });
                    this.jsonToCsv({ data: res.data["result"] });
                    sessionStorage.setItem(
                        "searchResults",
                        JSON.stringify(res.data["result"])
                    );

                    if (
                        window.location.pathname === "/dashboard/search/results"
                    ) {
                        window.location.reload();
                    } else {
                        history.push(`/dashboard/search/results`);
                    }
                }
            })
            .catch(error => {
                this.setState({ requestInProgress: false });
                history.push("/dashboard/search/no-results");
            });
    }
    resetQuery() {
  //    let query = {
  //         type: "acquirers",
  //    };
        let query = JSON.parse(sessionStorage.getItem("searchQuery"));
        if (query=== null)
        	query= { type: "acquirers"};
        this.setState({ query: query });
    }
    getQuery() {
        let query = JSON.parse(sessionStorage.getItem("searchQuery"));
        return query;
    }
    setQueryRedoSearch() {
        let query = JSON.parse(sessionStorage.getItem("searchQuery"));
        this.setState({ query: query });
    }
    // renders search results saved in session storage if page is refreshed
    refreshedSearchResults() {
        let results;

        if (
            this.state.searchResults.length === 0 &&
            sessionStorage.getItem("searchResults") !== null &&
            sessionStorage.getItem("searchQuery") !== null
        ) {
            results = JSON.parse(sessionStorage.getItem("searchResults"));
            let queryType = JSON.parse(sessionStorage.getItem("searchQuery"))[
                "type"
            ];
            this.setState({ query: { type: queryType } });
            this.setState({ searchResults: results});
            this.jsonToCsv({ data: results });
        } else if (this.state.searchResults.length !== 0) {
            results = this.state.searchResults;
        } else {
            window.location = "/404";
        }

        return results;
    }
    findCompanyInSearchResults() {
        let location = window.location.href.split("/");
        let companyId = location[location.length - 1];

        let results = JSON.parse(sessionStorage.getItem("searchResults"));

        let companyExists = results.some(x => {
            return results.indexOf(x) === companyId ? true : false;
        });

        let companyInfo = results.find(x => {
            return Number(results.indexOf(x)) === Number(companyId);
        });

        return { companyExists: companyExists, companyInfo: companyInfo };
    }
    toggleLeftSearchPanel() {
        this.setState({ revealSearchPanel: !this.state.revealSearchPanel });
    }
    findCompanyContacts() {
        // get query type from session storage
        let queryType = JSON.parse(sessionStorage.getItem("searchQuery"))[
            "type"
        ];

        if (queryType === "customers") {
            // get company id from url
            let location = window.location.href.split("/");
            let companyId = location[location.length - 1];
            // get search results from session storage
            let results = JSON.parse(sessionStorage.getItem("searchResults"));
            // get business type from session storage
            let customerBusiness = JSON.parse(
                sessionStorage.getItem("searchQuery")
            )["ownBusiness"];

            // find company data from search results
            let companyInfo = results.find(x => {
                return Number(results.indexOf(x)) === Number(companyId);
            });

            let selectedCompInfo = {
                company: companyInfo.name,
                company_url: companyInfo.domain,
                customer_business: customerBusiness
            };

            axios
                .post(
                    `${this.state.serverUrl}/service/financekb/find_contact`,
                    selectedCompInfo,
                    { withCredentials: true }
                )
                .then(res => {
                    this.setState({ companyContacts: res.data.result });
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    toggleCompanyContacts() {
        this.setState({ showCompanyContacts: !this.state.showCompanyContacts });
    }
    selectDataToExport(selectedRows) {
        // match company CIK to selectedRows key
        let matchedCompanyInfo = this.state.searchResults.filter(company =>
            selectedRows.some(s => company.cik === s.key)
        );
        this.jsonToCsv({
            data: matchedCompanyInfo
        });
    }
    jsonToCsv(args) {
        var result, ctr, keys, columnDelimiter, lineDelimiter, data;

        data = args.data || null;
        if (data == null || !data.length) {
            return null;
        }

        columnDelimiter = args.columnDelimiter || ",";
        lineDelimiter = args.lineDelimiter || "\n";

        keys = [
            "name",
            "score",
            "exchange_ticker",
            "mc",
            "grossmargin",
            "liabilities_ratio",
            "debt_to_ebitda",
            "cashandshortinvest",
            "acquisition_experience",
            "category",
            "country"
        ];

        result = "";
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        data.forEach(function(item) {
            item["name"] = item["name"].replace(new RegExp(",", "g"), "");
            item["category"] = item["category"].replace(
                new RegExp(",", "g"),
                ""
            );
            ctr = 0;
            keys.forEach(function(key) {
                if (ctr > 0) result += columnDelimiter;

                result += item[key];
                ctr++;
            });
            result += lineDelimiter;
        });

        this.setState({ dataToExport: result });
    }
    getAccountInfo() {
        axios
            .post(
                `${this.state.serverUrl}/service/webservice/get_account_info`,
                {
                    withCredentials: true
                }
            )
            .then(res => {
                //onsole.log(res.data);
                if (res.data.success === true) {
                    let accInfo = { basicInformation: {}, planSettings: {} };
                    accInfo.basicInformation.email = res.data.email;
                    accInfo.basicInformation.firstName = res.data.first_name;
                    accInfo.basicInformation.lastName = res.data.last_name;
                    accInfo.basicInformation.company = res.data.institution;
                    accInfo.planSettings.currentPlan = res.data.service_list;
                    this.setState({ accountInfo: accInfo });
                    sessionStorage.setItem(
                        "accountInfo",
                        JSON.stringify(accInfo)
                    );
                }
            })
            .catch(err => {
                console.log(err);
            });
    }
    refreshedAccountInfo() {
        let results;
        if (this.state.accountInfo.length === undefined) {
            results = JSON.parse(sessionStorage.getItem("accountInfo"));

            let updateAccountParams = this.state.updateAccountParams;
            updateAccountParams["email"] = results.basicInformation.email;
            updateAccountParams["firstName"] =
                results.basicInformation.firstName;
            updateAccountParams["lastName"] = results.basicInformation.lastName;
            updateAccountParams["company"] = results.basicInformation.company;
            this.setState({ updateAccountParams: updateAccountParams });
        } else {
            results = this.state.accountInfo;
        }
        return results;
    }
    postAccountChanges() {
        let u = this.state.updateAccountParams;

        let data = {
            email: u["email"],
            pass_word: u["password"]
        };

        if (u["newPassword"]) {
            data.new_pass_word = u["newPassword"];
        }
        if (u["firstName"]) {
            data.first_name = u["firstName"];
        }
        if (u["lastName"]) {
            data.last_name = u["lastName"];
        }
        if (u["company"]) {
            data.institution = u["company"];
        }

        axios
            .post(`${this.state.serverUrl}/service/service/update`, data, {
                withCredentials: true
            })
            .then(res => {
                this.getAccountInfo();
                if (res.data.success === true) {
                    alert(
                        "Account changes were successful! You will now be redirected back to your account page."
                    );
                    setTimeout(() => {
                        this.changeLocation("/dashboard/account");
                    }, 1000);
                } else {
                    alert(
                        `Account changes could not be made due to: ${res.data
                            .message}. Please try again.`
                    );
                }
            })
            .catch(err => {
                alert(
                    "We've encountered an error while trying to update your account. Please try again later."
                );
            });
    }
    unsubcribePlan(inputValPass) {
        if (inputValPass === "") {
            alert("Please enter a valid password.");
        } else {
            let storedData = JSON.parse(sessionStorage.getItem("accountInfo"));
            let userData = {
                email: storedData.basicInformation.email,
                pass_word: inputValPass,
                interests: storedData.planSettings.currentPlan.join("\t")
            };

            axios
                .post(
                    `${this.state
                        .serverUrl}/service/webservice/unsubscribe_acquisition_service`,
                    userData,
                    {
                        withCredentials: true
                    }
                )
                .then(res => {
                    if (res.data.success === true) {
                        sessionStorage.clear();
                        alert(
                            "You have successfully cancelled your FMeasure membership."
                        );
                        window.location = "/";
                    } else {
                        alert(
                            `Account changes could not be made due to ${res.data
                                .message}. Please try again.`
                        );
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    getRecentSearches() {
        axios
            .post(
                `${this.state
                    .serverUrl}/service/webservice/get_recent_searches`,
                {
                    withCredentials: true
                }
            )
            .then(res => {
                //console.log(res);
                this.setState({ recentSearches: res.data.result });
            })
            .catch(err => {
                console.log(err);
            });
    }
    getRecentAcq() {
        axios
            .post(
                `${this.state
                    .serverUrl}/service/financekb/get_recent_acquisitions`,
                { withCredentials: true }
            )
            .then(res => {
                //console.log(res);
                this.setState({ recentAcq: res.data.result });
            })
            .catch(err => {
                console.log(err);
            });
    }
    render() {
        return (
            <div
                style={{
                    overflow: this.state.revealSearchPanel === true && "hidden",
                    height: this.state.revealSearchPanel === true && "100vh"
                }}
            >
                <Nav
                    logo={Logo}
                    products={this.state.products}
                    user={this.state.user}
                    changeLocation={this.changeLocation}
                />
                <Router history={history}>
                    <Switch>
                        <Route
                            exact
                            path="/"
                            render={props => (
                                <SignIn
                                    {...props}
                                    loginParams={this.state.loginParams}
                                    onChangeInput={this.onChangeInput}
                                    postLogin={this.postLogin.bind(this)}
                                />
                            )}
                        />
                        <Route
                        	exact
                            path="/signup/success"
                            render={props => (
                                <Success
                                    {...props}
                                    successImg={SuccessImg}
                                    changeLocation={this.changeLocation}
                                />
                            )}
                        />
                        <Route
                        	exact
                            path="/signupbuyer/success"
                            render={props => (
                                <Success
                                    {...props}
                                    successImg={SuccessImg}
                                    changeLocation={this.changeLocation}
                                />
                            )}
                        />
                        <Route
                            exact
                            path="/dashboard"
                            render={props =>
                                this.verifyUser(
                                    <DashboardHome
                                    	{...props}
                                        accountInfo={this.state.accountInfo}
                                        requestInProgress={
                                            this.state.requestInProgress
                                        }
                                        resubmitSearchQuery={
                                            this.resubmitSearchQuery.bind(this)
                                        }
                                        recentSearches={
                                            this.state.recentSearches
                                        }
                                        recentAcq={this.state.recentAcq}
                                        refreshedAccountInfo={
                                            this.refreshedAccountInfo
                                        }
                                        requestSearchResults={
                                            this.requestSearchResults
                                        }
                                        getRecentSearches={this.getRecentSearches.bind(
                                            this
                                        )}
                                        getRecentAcq={this.getRecentAcq.bind(
                                            this
                                        )}
                                    />
                                )}
                        />
                        <Route
                        	exact
                            path="/dashboard/search/results"
                            render={props => (
                                <SearchResults
                                    {...props}
                                    query={this.state.query}
                                    countries={this.state.countries}
                                    getQuery={this.getQuery.bind(this)}
                                    searchResults={this.state.searchResults}
                                    returnIndustriesArray={
                                        this.returnIndustriesArray
                                    }
                                    refreshedSearchResults={
                                        this.refreshedSearchResults
                                    }
                                    selectDataToExport={this.selectDataToExport}
                                    dataToExport={this.state.dataToExport}
                                    changeLocation={this.changeLocation}
                                    changeLocation2={this.changeLocation2}
                                    searchProducts={this.state.searchProducts}
                                    addSearchTypeToQuery={
                                        this.addSearchTypeToQuery
                                    }
                                    buildSearchQuery={this.buildSearchQuery}
                                    moreFilters={this.state.moreFilters}
                                    toggleMoreFilters={this.toggleMoreFilters}
                                    toggleLeftSearchPanel={this.toggleLeftSearchPanel.bind(
                                        this
                                    )}
                                    revealSearchPanel={
                                        this.state.revealSearchPanel
                                    }
                                    setQueryRedoSearch={this.setQueryRedoSearch.bind(
                                        this
                                    )}
                                    validateSearchQuery={
                                        this.validateSearchQuery
                                    }
                                    requestInProgress={
                                        this.state.requestInProgress
                                    }
                                />
                            )}
                        />
                        <Route
                            exact
                            path="/dashboard/search"
                            render={props =>
                                this.verifyUser(
                                    <Search
                                        {...props}
                                        trianglify={Trianglify}
                                        returnIndustriesArray={
                                            this.returnIndustriesArray
                                        }
                                        resetQuery={this.resetQuery.bind(this)}
                                        query={this.state.query}
                                        moreFilters={this.state.moreFilters}
                                        toggleMoreFilters={
                                            this.toggleMoreFilters
                                        }
                                        requestInProgress={
                                            this.state.requestInProgress
                                        }
                                        countries={this.state.countries}
                                        buildSearchQuery={this.buildSearchQuery}
                                        addSearchTypeToQuery={
                                            this.addSearchTypeToQuery
                                        }
                                        searchProducts={
                                            this.state.searchProducts
                                        }
                                        validateSearchQuery={
                                            this.validateSearchQuery
                                        }
                                    />
                                )}
                        />
                        <Route
                        	exact
                            path="/dashboard/search/no-results"
                            render={props =>
                                this.verifyUser(
                                    <NoResults
                                        changeLocation={this.changeLocation}
                                    />
                                )}
                        />
                        <Route
                            exact
                            path="/dashboard/company/:id"
                            render={props =>
                                this.verifyUser(
                                    <CompanyResults
                                        {...props}
                                        changeLocation={this.changeLocation}
                                        changeLocation2={this.changeLocation2}
                                        searchResults={this.state.searchResults}
                                        companyContacts={
                                            this.state.companyContacts
                                        }
                                        showCompanyContacts={
                                            this.state.showCompanyContacts
                                        }
                                        getQuery={this.getQuery}
                                        findCompanyInSearchResults={this.findCompanyInSearchResults.bind(
                                            this
                                        )}
                                        findCompanyContacts={this.findCompanyContacts.bind(
                                            this
                                        )}
                                        toggleCompanyContacts={this.toggleCompanyContacts.bind(
                                            this
                                        )}
                                    />
                                )}
                        />
                        <Route
                            exact
                            path="/dashboard/account"
                            render={props =>
                                this.verifyUser(
                                    <Account
                                        {...props}
                                        changeLocation={this.changeLocation}
                                        logOutUser={this.logOutUser.bind(this)}
                                        refreshedAccountInfo={this.refreshedAccountInfo.bind(
                                            this
                                        )}
                                    />
                                )}
                        />
                        <Route
                        	exact
                            path="/dashboard/account/:section"
                            render={({ props, match }) =>
                                this.verifyUser(
                                    <EditAccount
                                        {...props}
                                        match={match}
                                        refreshedAccountInfo={
                                            this.refreshedAccountInfo
                                        }
                                        updateAccountParams={
                                            this.state.updateAccountParams
                                        }
                                        onChangeInput={this.onChangeInput}
                                        postAccountChanges={this.postAccountChanges.bind(
                                            this
                                        )}
                                        unsubcribePlan={this.unsubcribePlan}
                                    />
                                )}
                        />
                        <Route
                        	exact
                            path="/signup"
                            render={props => (
                                <SignUp
                                    {...props}
                                    trianglify={Trianglify}
                                    signUpParams={this.state.signUpParams}
                                    onChangeInput={this.onChangeInput}
                                    searchProducts={this.state.searchProducts}
                                    onboardingStep={this.state.onboardingStep}
                                    onboardingFlow={this.state.onboardingFlow}
                                    addToOnboardingCart={
                                        this.addToOnboardingCart
                                    }
                                    getSignUpProductTotal={this.getSignUpProductTotal.bind(
                                        this
                                    )}
                                    nextOnboarding={this.nextOnboarding.bind(
                                        this
                                    )}
                                    backOnboarding={this.backOnboarding.bind(
                                        this
                                    )}
                                    onToken={this.onToken.bind(this)}
                                />
                            )}
                        />
                        
                        <Route
                        	exact
                            path="/buyer_list"
                            render={props => (
                                <SignUpBuyer
                                    {...props}
                                    trianglify={Trianglify}
                                    signUpParamsBuyer={this.state.signUpParamsBuyer}
                                    onChangeInput={this.onChangeInput}
                                    onboardingStepBuyer={this.state.onboardingStepBuyer}
                                    onboardingFlowBuyer={this.state.onboardingFlowBuyer}
                                    getSignUpProductTotalBuyer={this.getSignUpProductTotalBuyer.bind(
                                        this
                                    )}
                                    nextOnboardingBuyer={this.nextOnboardingBuyer.bind(
                                        this
                                    )}
                                    backOnboardingBuyer={this.backOnboardingBuyer.bind(
                                        this
                                    )}
                                    onTokenBuyer={this.onTokenBuyer.bind(this)}
                                />
                            )}
                        />

                        
                       <Route
                       		exiact
                            path="/signup_trial"
                            render={props => (
                                <SignUp
                                    {...props}
                                    trianglify={Trianglify}
                                    signUpParams={this.state.signUpParams}
                                    onChangeInput={this.onChangeInput}
                                    searchProducts={this.state.searchProductsTrial}
                                    onboardingStep={this.state.onboardingStep}
                                    onboardingFlow={this.state.onboardingFlow}
                                    addToOnboardingCart={
                                        this.addToOnboardingCart
                                    }
                                    getSignUpProductTotal={this.getSignUpProductTotal.bind(
                                        this
                                    )}
                                    nextOnboarding={this.nextOnboarding.bind(
                                        this
                                    )}
                                    backOnboarding={this.backOnboarding.bind(
                                        this
                                    )}
                                   // onToken={this.onToken.bind(this)}
                                />
                            )}
                        />

                        <Route
                            render={props => (
                                <NoMatch
                                    {...props}
                                    changeLocation={this.changeLocation}
                                />
                            )}
                        />
                    </Switch>
                </Router>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js